export type SlotFilterSelectOption = {
  value: string;
  label: string;
};

export function sanitizeSlotFilterOptions(
  options: Array<{ value?: string | null; label?: string | null }>
): SlotFilterSelectOption[] {
  const seen = new Set<string>();

  return options
    .map((option) => {
      const value = String(option?.value ?? '').trim();
      if (!value) {
        return null;
      }

      const label = String(option?.label ?? value).trim() || value;
      return { value, label };
    })
    .filter((item): item is SlotFilterSelectOption => {
      if (!item || seen.has(item.value)) {
        return false;
      }

      seen.add(item.value);
      return true;
    });
}

export function sanitizeSelectedSlotFilterValues(
  values: Array<string | null | undefined> | string | null | undefined,
  options: SlotFilterSelectOption[]
): string[] {
  const normalized = Array.isArray(values)
    ? values
    : values
      ? [values]
      : [];

  return [...new Set(
    normalized
      .map((value) => String(value ?? '').trim())
      .filter((value) => value.length > 0 && options.some((option) => option.value === value))
  )];
}
